export { SalaryChip } from './SalaryChip';
